import { getCookie } from 'cookies-next'

import { ACCEPT_COOKIE_KEY } from 'lib/utils/cookies'

export const userAccepptedCookies =
  typeof window !== 'undefined' && getCookie(ACCEPT_COOKIE_KEY) === 'true'
